// 开启计时器
let timer = null

export default {
    timerStart ({ commit }) {
        if (!timer) {
            // console.log('timerStart')
            const interval = 1000
            timer = setInterval(() => {
                commit('update')
            }, interval)
        }
    },
// 停止计时器
    timerStop () {
        // console.log('timerStop')
        if (timer) {
            clearInterval(timer)
        }
        timer = null
    }
}
